import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import { AuthProvider } from './components/AuthProvider';
import { SettingsProvider } from './hooks/settings';

import './index.css';

// Système de log détaillé pour production
console.log('═══════════════════════════════════════════════════════');
console.log('🚀 APPLICATION START - Cold Sales System');
console.log('═══════════════════════════════════════════════════════');
console.log('📅 Timestamp:', new Date().toISOString());
console.log('🌍 Location:', window.location.href);
console.log('🔧 Environment:', import.meta.env.MODE);
console.log('📦 React Version:', '18.3.1');
console.log('🔍 Variables d\'environnement:');
console.log('  - VITE_SUPABASE_URL:', import.meta.env.VITE_SUPABASE_URL ? '✓ Définie' : '✗ MANQUANTE');
console.log('  - VITE_SUPABASE_ANON_KEY:', import.meta.env.VITE_SUPABASE_ANON_KEY ? '✓ Définie' : '✗ MANQUANTE');
console.log('  - VITE_APP_URL:', import.meta.env.VITE_APP_URL || 'Non définie');
console.log('═══════════════════════════════════════════════════════');

try {
  console.log('🔍 Recherche de l\'élément root...');
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    console.error('❌ ERREUR CRITIQUE: Element root introuvable!');
    throw new Error('Failed to find the root element');
  }
  
  console.log('✅ Element root trouvé:', rootElement);
  console.log('🎨 Création de la racine React...');
  const root = createRoot(rootElement);
  console.log('✅ Racine React créée avec succès');
  
  console.log('🎬 Rendu de l\'application...');
  console.log('  - StrictMode: Activé');
  console.log('  - BrowserRouter: Configuration v7');
  console.log('  - ErrorBoundary: Activé');
  console.log('  - HelmetProvider: Activé');
  console.log('  - SettingsProvider: Activé');
  console.log('  - AuthProvider: Activé');
  
  root.render(
    <StrictMode>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <ErrorBoundary>
          <HelmetProvider>
            <SettingsProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </SettingsProvider>
          </HelmetProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </StrictMode>
  );
  
  console.log('✅ Application rendue avec succès!');
  console.log('═══════════════════════════════════════════════════════');
  
} catch (error) {
  console.error('═══════════════════════════════════════════════════════');
  console.error('❌ ERREUR FATALE LORS DE L\'INITIALISATION');
  console.error('═══════════════════════════════════════════════════════');
  console.error('Type:', error instanceof Error ? error.name : typeof error);
  console.error('Message:', error instanceof Error ? error.message : error);
  console.error('Stack:', error instanceof Error ? error.stack : 'N/A');
  console.error('═══════════════════════════════════════════════════════');
  
  // Display error message in the root element
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 20px; color: #721c24; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px;">
        <h2>Application Error</h2>
        <p>${error instanceof Error ? error.message : 'An unknown error occurred'}</p>
        <p>Please check the browser console for more details.</p>
      </div>
    `;
  }
}
